import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { centsEur, sendBlocker } from "@/lib/documents";
import type { DocumentDetail } from "@/lib/types";

/** Sticky at the bottom of the editor: count, tax line, total and the way out. */
export function EditorFooter({ detail, onSend }: { detail: DocumentDetail; onSend: () => void }) {
  const doc = detail.document;
  const n = doc.positions.length;
  // The dialog itself takes a recipient and the Kleinunternehmer override; anything else blocks opening it.
  const blocked = sendBlocker(detail.validation);
  // aria-disabled instead of disabled: the button keeps focus and hover, so the tooltip can say why it is blocked.
  const send = (
    <Button
      className="pointer-coarse:h-11 aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-disabled:hover:bg-primary motion-safe:aria-disabled:active:scale-100"
      aria-disabled={blocked !== null || undefined}
      onClick={(e) => {
        if (blocked !== null) e.preventDefault();
        else onSend();
      }}
    >
      Prüfen &amp; senden
    </Button>
  );
  return (
    <div className="sticky bottom-0 z-10 -mx-4 mt-1 flex flex-wrap items-center gap-x-5 gap-y-2 border-t bg-background px-4 py-3 max-sm:bottom-[calc(3.5rem+1px+env(safe-area-inset-bottom))]">
      <span className="text-[0.8125rem] text-muted-foreground">{n === 1 ? "1 Position" : `${n} Positionen`}</span>
      <span className="text-[0.8125rem] text-muted-foreground">USt 0,00 € (Kleinunternehmer)</span>
      <span className="text-lg font-semibold tracking-[-0.01em] tabular-nums">{centsEur(doc.totalCents)}</span>
      <div className="ml-auto">
        {blocked ? (
          <Tooltip>
            <TooltipTrigger asChild>{send}</TooltipTrigger>
            <TooltipContent side="top" align="end">{blocked}</TooltipContent>
          </Tooltip>
        ) : send}
      </div>
    </div>
  );
}
